import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@yuno/design-system-web'
import { useForm } from 'react-hook-form'
import { CheckboxStyled, ContentStyled, RowStyled, SubTitle, TypographyStyled } from '../styles'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const ConnectionAccountsForm = ({ accounts, onSubmit, actualAccountName }) => {
  const { t } = useTranslation()
  const defaultValues = () => {
    let valuesObj = {}
    accounts.map((account) => {
      valuesObj[account.code] = false
    })
    return valuesObj
  }

  const handleSubmitConfirmForm = (values) => {
    onSubmit(values)
  }

  const { register, handleSubmit, control, setValue, reset } = useForm({
    mode: 'onChange',
    defaultValues: {
      ...defaultValues,
      default: true,
    },
  })

  const changeDefault = (e, value) => {
    setValue(e.target.name, value)
    if (e.target.name === 'default') {
      reset({ ...defaultValues })
      setValue('default', true)
    } else {
      setValue('default', false)
    }
  }

  return (
    <>
      <ContentStyled>
        <Typography>
          {`${t('changesAppliedOne')}${actualAccountName}${t('changesAppliedTwo')}`}
        </Typography>
        <Typography>{t('changesAppliedFinal')}</Typography>
      </ContentStyled>
      <form
        id="connection-form"
        onSubmit={handleSubmit(handleSubmitConfirmForm)}
      >
        <SubTitle>{t('selectOptions')}</SubTitle>

        {accounts?.map((account) => {
          return (
            <Controller
              control={control}
              name={account.code}
              render={({ field, fieldState, formState, ...props }) => {
                return (
                  <RowStyled>
                    <CheckboxStyled
                      disableRipple
                      checked={!!field.value}
                      size="small"
                      {...register(account.code)}
                      onChange={changeDefault.bind(null)}
                    />
                    <TypographyStyled variant="caption">{account.name}</TypographyStyled>
                  </RowStyled>
                )
              }}
            />
          )
        })}
        <Controller
          control={control}
          name={'default'}
          render={({ field, fieldState, formState, ...props }) => {
            return (
              <RowStyled>
                <CheckboxStyled
                  disableRipple
                  checked={!!field.value}
                  size="small"
                  {...register('default')}
                  onChange={changeDefault.bind(null)}
                />
                <TypographyStyled variant="caption">
                  {t('noCurrentAccount')}
                </TypographyStyled>
              </RowStyled>
            )
          }}
        />
      </form>
    </>
  )
}

export default ConnectionAccountsForm
